import { jsxs, jsx } from "react/jsx-runtime";
import { $generateHtmlFromNodes, $generateNodesFromDOM } from "@lexical/html";
import { $convertToMarkdownString, TRANSFORMERS } from "@lexical/markdown";
import { LexicalComposer } from "@lexical/react/LexicalComposer";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { ContentEditable } from "@lexical/react/LexicalContentEditable";
import { LexicalErrorBoundary } from "@lexical/react/LexicalErrorBoundary";
import { HistoryPlugin } from "@lexical/react/LexicalHistoryPlugin";
import { LinkPlugin } from "@lexical/react/LexicalLinkPlugin";
import { ListPlugin } from "@lexical/react/LexicalListPlugin";
import { OnChangePlugin } from "@lexical/react/LexicalOnChangePlugin";
import { RichTextPlugin } from "@lexical/react/LexicalRichTextPlugin";
import { $getSelection, $isRangeSelection, $createTextNode, SELECTION_CHANGE_COMMAND, COMMAND_PRIORITY_LOW, FORMAT_TEXT_COMMAND, $getRoot, $createParagraphNode } from "lexical";
import React, { useRef, useState, useMemo, useCallback, useEffect, forwardRef, useImperativeHandle } from "react";
import { $isListNode, REMOVE_LIST_COMMAND, INSERT_UNORDERED_LIST_COMMAND, INSERT_ORDERED_LIST_COMMAND, ListNode, ListItemNode } from "@lexical/list";
import { $createLinkNode, LinkNode } from "@lexical/link";
import { HeadingNode, QuoteNode } from "@lexical/rich-text";
const M = "undefined" != typeof window && void 0 !== window.document && void 0 !== window.document.createElement, R = M && "documentMode" in document ? document.documentMode : null;
!(!M || !("InputEvent" in window) || R) && "getTargetRanges" in new window.InputEvent("input");
function j(...t) {
  return () => {
    for (let e = t.length - 1; e >= 0; e--)
      t[e]();
    t.length = 0;
  };
}
const emojisMap = {
  grinning: "😀",
  beaming: "😁",
  joy: "😂",
  smile: "😃",
  wink: "😉",
  yum: "😋",
  sunglasses: "😎",
  heart_eyes: "😍",
  kissing: "😗",
  hugging: "🤗",
  thinking: "🤔",
  persevere: "😣",
  tired: "😫",
  sleeping: "😴",
  relieved: "😌",
  nerd: "🤓",
  tongue: "😛",
  winking_tongue: "😜",
  angry: "😠",
  innocent: "😇",
  mask: "😷",
  ghost: "👻",
  smile_cat: "😺",
  smiley_cat: "😸",
  joy_cat: "😹",
  heart_eyes_cat: "😻",
  smirk_cat: "😼",
  kissing_cat: "😽",
  scream_cat: "🙀",
  see_no_evil: "🙈",
  hear_no_evil: "🙉",
  speak_no_evil: "🙊",
  angel: "👼",
  police_officer: "👮",
  detective: "🕵",
  guard: "💂",
  turban: "👳",
  santa: "🎅",
  princess: "👸",
  bride: "👰",
  chinese_cap: "👲",
  frowning: "🙍",
  bow: "🙇",
  walking: "🚶",
  runner: "🏃",
  dancer: "💃",
  skier: "⛷",
  snowboarder: "🏂",
  golfer: "🏌",
  surfer: "🏄",
  rowboat: "🚣",
  swimmer: "🏊",
  ball_player: "⛹",
  weightlifter: "🏋",
  bicyclist: "🚴",
  couple: "👫",
  muscle: "💪",
  point_left: "👈",
  point_right: "👉",
  vulcan: "🖖",
  metal: "🤘",
  hand_splayed: "🖐",
  ok: "👌",
  thumbsup: "👍",
  thumbsdown: "👎",
  fist: "✊",
  punch: "👊",
  clap: "👏",
  raised_hands: "🙌",
  pray: "🙏",
  monkey: "🐵",
  dog: "🐶",
  rabbit: "🐇",
  chick: "🐥",
  frog: "🐸",
  snail: "🐌",
  bug: "🐛",
  ant: "🐜",
  bee: "🐝",
  watermelon: "🍉",
  mushroom: "🍄",
  burger: "🍔",
  fried_shrimp: "🍤",
  icecream: "🍨",
  cookie: "🍪",
  cake: "🎂",
  shortcake: "🍰",
  champagne: "🍾",
  wine: "🍷",
  cocktail: "🍸",
  beer: "🍺",
  globe: "🌍",
  ambulance: "🚑",
  alarm_clock: "⏰",
  moon: "🌙",
  full_moon_face: "🌝",
  sun_face: "🌞",
  star: "⭐",
  glowing_star: "🌟",
  shooting_star: "🌠",
  snow_cloud: "🌨",
  lightning_cloud: "🌩",
  snowman: "⛄",
  fire: "🔥",
  christmas_tree: "🎄",
  balloon: "🎈",
  party_popper: "🎉",
  confetti: "🎊",
  gift: "🎁",
  ribbon: "🎗",
  basketball: "🏀",
  football: "🏈",
  dice: "🎲",
  mute: "🔇",
  speaker: "🔈",
  megaphone: "📣",
  bell: "🔔",
  musical_note: "🎵",
  saxophone: "🎷",
  moneybag: "💰",
  pen: "🖊",
  calendar: "📅",
  checkmark: "✅",
  crossmark: "❎",
  hundred: "💯",
  chili: "🌶",
  croissant: "🥐",
  stew: "🥘",
  lobster: "🦞",
  crab: "🦀",
  soft_icecream: "🍦",
  baby_bottle: "🍼",
  tropical_drink: "🍹",
  beers: "🍻",
  clinking_glasses: "🥂",
  ring: "💍",
  rainbow_flag: "🏳️‍🌈",
  round_pushpin: "📍",
  cowboy: "🤠",
  airplane: "🛩",
  beach: "🏖",
  island: "🏝",
  wave: "🌊",
  mountain: "🏔",
  sunrise: "🌅",
  train: "🚂",
  taxi: "🚕",
  car: "🚗",
  ship: "🚢",
  luggage: "🧳",
  sandals: "🩴",
  trophy: "🏆",
  soccer: "⚽",
  diving_mask: "🤿",
  soap: "🧼",
  teddy_bear: "🧸"
};
const InsertEmojiModal = ({ onClose, onConfirm }) => {
  const [editor] = useLexicalComposerContext();
  const dialogRef = useRef(null);
  const [searchQuery, setSearchQuery] = useState("");
  const filteredEmojis = useMemo(() => {
    const entries = Object.entries(emojisMap);
    const q = searchQuery.trim().toLowerCase();
    if (!q)
      return entries;
    return entries.filter(
      ([name, emoji]) => name.toLowerCase().includes(q) || emoji.includes(searchQuery)
    );
  }, [searchQuery]);
  const insertEmoji = useCallback(
    (emoji) => {
      editor.update(() => {
        const selection = $getSelection();
        if ($isRangeSelection(selection))
          selection.insertText(emoji);
      });
      onConfirm == null ? void 0 : onConfirm(emoji);
      onClose == null ? void 0 : onClose();
    },
    [editor, onConfirm, onClose]
  );
  return /* @__PURE__ */ jsxs("div", { className: "iem-overlay", role: "presentation", children: [
    /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        className: "iem-overlay-click-target",
        "aria-label": "Close emoji picker",
        onClick: onClose
      }
    ),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: "iem-modal",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "iem-title",
        ref: dialogRef,
        children: [
          /* @__PURE__ */ jsxs("div", { className: "iem-header", children: [
            /* @__PURE__ */ jsx("span", { id: "iem-title", className: "iem-title", children: "Insert Emoji" }),
            /* @__PURE__ */ jsx(
              "input",
              {
                type: "text",
                className: "iem-search",
                placeholder: "Search...",
                value: searchQuery,
                onChange: (e) => setSearchQuery(e.target.value)
              }
            ),
            /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                className: "iem-close",
                "aria-label": "Close",
                onClick: onClose,
                children: /* @__PURE__ */ jsx("svg", { width: "18", height: "18", viewBox: "0 0 18 18", "aria-hidden": "true", children: /* @__PURE__ */ jsx(
                  "path",
                  {
                    d: "M4 4l10 10M14 4L4 14",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round"
                  }
                ) })
              }
            )
          ] }),
          /* @__PURE__ */ jsx("div", { className: "iem-body", children: filteredEmojis.map(([name, emoji]) => /* @__PURE__ */ jsx(
            "button",
            {
              title: name,
              type: "button",
              className: "iem-emoji-button",
              onClick: () => insertEmoji(emoji),
              children: emoji
            },
            name
          )) })
        ]
      }
    )
  ] });
};
const isValid = (value) => URL.canParse ? URL.canParse(value) : false;
const insertLinkWithText = (editor, title, url) => {
  editor.update(() => {
    const selection = $getSelection();
    if (!$isRangeSelection(selection))
      return;
    const link = $createLinkNode(url);
    link.append($createTextNode(title));
    selection.insertNodes([link]);
  });
};
const InsertLinkModal = ({ open = false, onClose, onConfirm }) => {
  const [editor] = useLexicalComposerContext();
  const dialogRef = useRef(null);
  const rowsRef = useRef(null);
  const [linkTitle, setLinkTitle] = useState("");
  const [linkURL, setLinkURL] = useState("");
  useEffect(() => {
    editor.getEditorState().read(() => {
      const selection = $getSelection();
      if ($isRangeSelection(selection)) {
        const selectedText = selection.getTextContent();
        setLinkTitle(selectedText);
      }
    });
  }, []);
  const handleConfirm = () => {
    if (isValid(linkURL)) {
      insertLinkWithText(editor, linkTitle, linkURL);
      onConfirm == null ? void 0 : onConfirm(linkTitle, linkURL);
    }
  };
  if (!open)
    return null;
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: "ilm-overlay",
      role: "presentation",
      onMouseDown: (e) => {
        if (e.target.classList.contains("ilm-overlay"))
          onClose == null ? void 0 : onClose();
      },
      children: /* @__PURE__ */ jsxs(
        "div",
        {
          className: "ilm-modal",
          role: "dialog",
          "aria-modal": "true",
          "aria-labelledby": "ilm-title",
          ref: dialogRef,
          children: [
            /* @__PURE__ */ jsxs("div", { className: "ilm-header", children: [
              /* @__PURE__ */ jsx("h3", { id: "ilm-title", className: "ilm-title", children: "Insert Link" }),
              /* @__PURE__ */ jsx(
                "button",
                {
                  type: "button",
                  className: "ilm-close",
                  "aria-label": "Close",
                  onClick: onClose,
                  children: /* @__PURE__ */ jsx("svg", { width: "18", height: "18", viewBox: "0 0 18 18", "aria-hidden": "true", children: /* @__PURE__ */ jsx(
                    "path",
                    {
                      d: "M4 4l10 10M14 4L4 14",
                      fill: "none",
                      stroke: "currentColor",
                      strokeWidth: "2",
                      strokeLinecap: "round"
                    }
                  ) })
                }
              )
            ] }),
            /* @__PURE__ */ jsxs("div", { className: "ilm-body", children: [
              /* @__PURE__ */ jsx("label", { className: "ilm-label", htmlFor: "ilm-title", children: "Link Title" }),
              /* @__PURE__ */ jsx(
                "input",
                {
                  id: "ilm-title",
                  ref: rowsRef,
                  className: "ilm-input",
                  inputMode: "text",
                  value: linkTitle,
                  onChange: (e) => {
                    setLinkTitle(e.target.value);
                  }
                }
              ),
              /* @__PURE__ */ jsx("label", { className: "ilm-label", htmlFor: "ilm-target", children: "Link Target" }),
              /* @__PURE__ */ jsx(
                "input",
                {
                  id: "ilm-target",
                  className: "ilm-input",
                  inputMode: "url",
                  placeholder: "https://",
                  value: linkURL,
                  onChange: (e) => {
                    setLinkURL(e.target.value);
                  }
                }
              )
            ] }),
            /* @__PURE__ */ jsxs("div", { className: "ilm-footer", children: [
              /* @__PURE__ */ jsx("button", { type: "button", className: "ilm-btn ilm-btn--cancel", onClick: onClose, children: "Cancel" }),
              /* @__PURE__ */ jsx(
                "button",
                {
                  type: "button",
                  className: "ilm-btn ilm-btn--confirm",
                  onClick: handleConfirm,
                  disabled: !linkTitle || !linkURL || !isValid(linkURL),
                  children: "Confirm"
                }
              )
            ] })
          ]
        }
      )
    }
  );
};
const QuickRepliesModal = ({ quickReplies, onClose }) => {
  const [editor] = useLexicalComposerContext();
  const dialogRef = useRef(null);
  const [path, setPath] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const isLeaf = (n) => !n.children || n.children.length === 0;
  const getQuickReplyByPath = (nodes, p) => {
    if (p.length === 0)
      return null;
    let current;
    let level = nodes;
    for (const id of p) {
      current = level.find((x) => x.id === id);
      if (!current)
        return null;
      level = current.children ?? [];
    }
    return current ?? null;
  };
  const listChildren = (nodes, p) => {
    if (p.length === 0)
      return nodes;
    const node = getQuickReplyByPath(nodes, p);
    return (node == null ? void 0 : node.children) ?? [];
  };
  const enter = (p, id) => [...p, id];
  const goBack = (p) => p.slice(0, -1);
  const collectAllLeaves = (nodes, basePath = []) => {
    const acc = [];
    const dfs = (arr, currentPath) => {
      for (const n of arr) {
        const p = [...currentPath, n.id];
        if (isLeaf(n)) {
          acc.push({ node: n, path: p });
        } else if (n.children && n.children.length) {
          dfs(n.children, p);
        }
      }
    };
    dfs(nodes, basePath);
    return acc;
  };
  const highlightMatches = (text, query) => {
    if (!query)
      return [{ text, match: false }];
    const lowerText = text.toLowerCase();
    const lowerQ = query.toLowerCase();
    const segments = [];
    let i = 0;
    while (i < text.length) {
      const idx = lowerText.indexOf(lowerQ, i);
      if (idx === -1) {
        segments.push({ text: text.slice(i), match: false });
        break;
      }
      if (idx > i)
        segments.push({ text: text.slice(i, idx), match: false });
      segments.push({ text: text.slice(idx, idx + query.length), match: true });
      i = idx + query.length;
    }
    return segments.length ? segments : [{ text, match: false }];
  };
  const searchLeavesGlobal = (nodes, query) => {
    const q = query.trim().toLowerCase();
    if (!q)
      return [];
    const leaves = collectAllLeaves(nodes);
    const matches = leaves.filter(({ node }) => node.text.toLowerCase().includes(q)).map(({ node, path: path2 }) => ({
      id: node.id,
      text: node.text,
      path: path2,
      segments: highlightMatches(node.text, query)
    }));
    matches.sort((a, b) => a.text.localeCompare(b.text) || a.path.length - b.path.length);
    return matches;
  };
  const getTitleById = (nodes, id) => {
    const queue = [...nodes];
    while (queue.length) {
      const n = queue.shift();
      if (n.id === id)
        return n.text;
      if (n.children)
        queue.push(...n.children);
    }
    return null;
  };
  const pathToBreadcrumb = (nodes, p) => p.map((id) => getTitleById(nodes, String(id)) ?? "—");
  const browseItems = useMemo(() => listChildren(quickReplies, path), [quickReplies, path]);
  const searchResults = useMemo(
    () => searchLeavesGlobal(quickReplies, searchQuery),
    [quickReplies, searchQuery]
  );
  const handleConfirm = useCallback(
    (text) => {
      editor.update(() => {
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
          selection.insertText(text);
        }
      });
      onClose == null ? void 0 : onClose();
    },
    [editor, onClose]
  );
  const handleConfirmKeyEnter = (e, text) => {
    if (e.key !== "Enter" && e.key !== " ")
      return;
    e.preventDefault();
    handleConfirm(text);
  };
  const handleItemClick = (item) => {
    if (isLeaf(item)) {
      handleConfirm(item.text);
    } else if (item.children && item.children.length) {
      setPath((p) => enter(p, String(item.id)));
    }
  };
  const handleItemKeyEnter = (e, item) => {
    if (e.key !== "Enter" && e.key !== " ")
      return;
    e.preventDefault();
    handleItemClick(item);
  };
  const showBack = path.length > 0;
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: "qrm-overlay",
      role: "presentation",
      onMouseDown: (e) => {
        if (e.target.classList.contains("qrm-overlay"))
          onClose == null ? void 0 : onClose();
      },
      children: /* @__PURE__ */ jsx(
        "div",
        {
          className: "qrm-modal",
          role: "dialog",
          "aria-modal": "true",
          "aria-labelledby": "qrm-title",
          ref: dialogRef,
          children: /* @__PURE__ */ jsxs("div", { className: "qrm-wrapper", children: [
            /* @__PURE__ */ jsxs("div", { className: "qrm-header", children: [
              showBack ? /* @__PURE__ */ jsxs(
                "button",
                {
                  type: "button",
                  className: "qrm-back",
                  "aria-label": "Back",
                  onClick: () => setPath((p) => goBack(p)),
                  children: [
                    /* @__PURE__ */ jsx("svg", { width: "18", height: "18", viewBox: "0 0 18 18", "aria-hidden": "true", children: /* @__PURE__ */ jsx(
                      "path",
                      {
                        d: "M11.5 3.5L6 9l5.5 5.5",
                        fill: "none",
                        stroke: "#00856f",
                        strokeWidth: "2",
                        strokeLinecap: "round"
                      }
                    ) }),
                    /* @__PURE__ */ jsx("span", { className: "qrm-title", children: "Back" })
                  ]
                }
              ) : /* @__PURE__ */ jsx("span", { id: "qrm-title", className: "qrm-title", children: "Quick replies" }),
              /* @__PURE__ */ jsx(
                "input",
                {
                  type: "text",
                  className: "qrm-search",
                  placeholder: "Search...",
                  value: searchQuery,
                  onChange: (e) => setSearchQuery(e.target.value)
                }
              ),
              /* @__PURE__ */ jsx(
                "button",
                {
                  type: "button",
                  className: "qrm-close",
                  "aria-label": "Close",
                  onClick: onClose,
                  children: /* @__PURE__ */ jsx("svg", { width: "18", height: "18", viewBox: "0 0 18 18", "aria-hidden": "true", children: /* @__PURE__ */ jsx(
                    "path",
                    {
                      d: "M4 4l10 10M14 4L4 14",
                      fill: "none",
                      stroke: "currentColor",
                      strokeWidth: "2",
                      strokeLinecap: "round"
                    }
                  ) })
                }
              )
            ] }),
            /* @__PURE__ */ jsxs("div", { className: "qrm-body", children: [
              browseItems.length === 0 && /* @__PURE__ */ jsx("p", { className: "qrm-empty", children: "No quick replies configured" }),
              searchQuery.trim() !== "" && searchResults.length === 0 && /* @__PURE__ */ jsx("p", { className: "qrm-empty", children: "No quick replies found" }),
              browseItems.length && searchQuery.trim() === "" ? /* @__PURE__ */ jsx("ul", { className: "qrm-list", role: "listbox", "aria-label": "Quick replies", children: browseItems.map((item) => {
                const leaf = isLeaf(item);
                return /* @__PURE__ */ jsxs(
                  "li",
                  {
                    className: `qrm-item ${leaf ? "qrm-leaf" : "qrm-folder"}`,
                    role: "option",
                    onClick: () => handleItemClick(item),
                    onKeyDown: (e) => handleItemKeyEnter(e, item),
                    "aria-selected": false,
                    children: [
                      /* @__PURE__ */ jsx("span", { className: "qrm-text", children: item.text }),
                      !leaf ? /* @__PURE__ */ jsx("span", { className: "qrm-chevron", "aria-hidden": "true", children: /* @__PURE__ */ jsx("svg", { width: "18", height: "18", viewBox: "0 0 18 18", children: /* @__PURE__ */ jsx(
                        "path",
                        {
                          d: "M6.5 3.5L12 9l-5.5 5.5",
                          fill: "none",
                          stroke: "#00856f",
                          strokeWidth: "2",
                          strokeLinecap: "round"
                        }
                      ) }) }) : null
                    ]
                  },
                  item.id
                );
              }) }) : searchResults.length > 0 && /* @__PURE__ */ jsx("ul", { className: "qrm-list", role: "listbox", "aria-label": "Search results", children: searchResults.map((m) => /* @__PURE__ */ jsx(
                "li",
                {
                  className: "qrm-item qrm-leaf",
                  role: "option",
                  onClick: () => handleConfirm(m.text),
                  onKeyDown: (e) => handleConfirmKeyEnter(e, m.text),
                  title: pathToBreadcrumb(quickReplies, m.path).join(
                    " / "
                  ),
                  "aria-selected": false,
                  children: /* @__PURE__ */ jsx("span", { className: "qrm-text", children: m.segments.map(
                    (s, i) => s.match ? /* @__PURE__ */ jsx("mark", { className: "qrm-highlight", children: s.text }, i) : /* @__PURE__ */ jsx("span", { children: s.text }, i)
                  ) })
                },
                m.id + m.path.join("/")
              )) })
            ] })
          ] })
        }
      )
    }
  );
};
const QuickReplies = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M17%2010.4994L10.4731%2021.1666L11.5204%2013.5016H7L13.5251%202.83331L11.9962%2010.4994H17Z'%20fill='%23353535'/%3e%3c/svg%3e";
const Bold = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M7%2018.6667V6.16666H12.3935C13.7882%206.16666%2014.8503%206.47023%2015.5797%207.07737C16.3218%207.67261%2016.6929%208.44047%2016.6929%209.38094C16.6929%2010.1667%2016.4626%2010.7976%2016.0019%2011.2738C15.5541%2011.7381%2015.0038%2012.0536%2014.3512%2012.2202C15.119%2012.3631%2015.7524%2012.7202%2016.2514%2013.2917C16.7505%2013.8512%2017%2014.5059%2017%2015.2559C17%2016.244%2016.6161%2017.0595%2015.8484%2017.7024C15.0806%2018.3452%2013.993%2018.6667%2012.5854%2018.6667H7ZM9.45681%2011.4167H12.0288C12.7198%2011.4167%2013.2508%2011.2678%2013.6219%2010.9702C13.993%2010.6726%2014.1785%2010.25%2014.1785%209.70237C14.1785%209.17856%2013.993%208.76785%2013.6219%208.47023C13.2636%208.1607%2012.7198%208.00594%2011.9904%208.00594H9.45681V11.4167ZM9.45681%2016.8095H12.2015C12.9309%2016.8095%2013.4939%2016.6548%2013.8906%2016.3452C14.3001%2016.0238%2014.5048%2015.5774%2014.5048%2015.0059C14.5048%2014.4226%2014.2937%2013.9643%2013.8714%2013.6309C13.4491%2013.2976%2012.8797%2013.1309%2012.1631%2013.1309H9.45681V16.8095Z'%20fill='%23495057'/%3e%3c/svg%3e";
const Italic = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M13.4917%207.22294C13.1375%207.17708%2012.8619%207.02721%2012.6649%206.77333C12.4839%206.50725%2012.4156%206.20582%2012.46%205.86902C12.5119%205.4761%2012.6786%205.14086%2012.9602%204.86331C13.2577%204.57357%2013.6261%204.45713%2014.0653%204.51399C14.4194%204.55985%2014.6941%204.71674%2014.8893%204.98465C15.0863%205.23853%2015.1598%205.55491%2015.1098%205.93381C15.058%206.32673%2014.8851%206.65404%2014.5912%206.91571C14.3115%207.17923%2013.945%207.28163%2013.4917%207.22294ZM10.3801%209.83875L10.5023%208.91257L14.0613%208.96661L13.8363%2010.6716L11.6049%2017.9188L13.1348%2018.1169L13.007%2019.0852C12.9448%2019.1199%2012.8001%2019.1797%2012.5728%2019.2644C12.3615%2019.337%2012.0793%2019.4004%2011.7264%2019.4546C11.3876%2019.5106%2011.034%2019.5148%2010.6657%2019.4671C10.1982%2019.4066%209.87736%2019.2723%209.70311%2019.0641C9.52885%2018.856%209.46672%2018.5625%209.51672%2018.1836C9.54635%2017.9591%209.60616%2017.7242%209.69615%2017.479L11.9904%2010.4112L10.3801%209.83875Z'%20fill='%23495057'/%3e%3c/svg%3e";
const Underline = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M11.9767%2017.2157C11.2008%2017.2157%2010.4973%2017.0657%209.86623%2016.7657C9.2455%2016.4553%208.74891%2015.9846%208.37647%2015.3535C8.01438%2014.7224%207.83333%2013.9206%207.83333%2012.9482V6.16666H9.47827V12.9637C9.47827%2013.9155%209.70588%2014.6138%2010.1611%2015.0586C10.6163%2015.5035%2011.2318%2015.7259%2012.0078%2015.7259C12.7733%2015.7259%2013.3837%2015.5035%2013.8389%2015.0586C14.2941%2014.6138%2014.5217%2013.9155%2014.5217%2012.9637V6.16666H16.1667V12.9482C16.1667%2013.9206%2015.9753%2014.7224%2015.5925%2015.3535C15.22%2015.9846%2014.7131%2016.4553%2014.0717%2016.7657C13.4406%2017.0657%2012.7423%2017.2157%2011.9767%2017.2157Z'%20fill='%23495057'/%3e%3cpath%20d='M7%2018.6667H17V19.5H7V18.6667Z'%20fill='%23495057'/%3e%3c/svg%3e";
const Ordered = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M7.81909%2017.8333H5.33325V17H6.99075V16.5833H6.16242V15.75H6.99159V15.3333H5.33325V14.5H7.81909V17.8333ZM19.4999%2017H9.55742V15.3333H19.4999V17ZM7.81909%2013.6667H5.33325V12.9167L6.82492%2011.1667H5.33325V10.3333H7.81909V11.0833L6.32742%2012.8333H7.81909V13.6667ZM19.4999%2012.8333H9.55742V11.1667H19.4999V12.8333ZM7.40492%209.49999H6.57575V6.99999H5.74992V6.16666H7.40492V9.49999ZM19.4999%208.66666H9.55742V6.99999H19.4999V8.66666Z'%20fill='%23495057'/%3e%3c/svg%3e";
const Unordered = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M18.6666%2017H8.66659V15.3333H18.6666V17ZM6.99992%2017H5.33325V15.3333H6.99992V17ZM18.6666%2012.8333H8.66659V11.1667H18.6666V12.8333ZM6.99992%2012.8333H5.33325V11.1667H6.99992V12.8333ZM18.6666%208.66667H8.68575V7H18.6666V8.66667ZM6.99992%208.66667H5.33325V7H6.99992V8.66667Z'%20fill='%23495057'/%3e%3c/svg%3e";
const Emoji = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M12.0001%2020.3334C7.39771%2020.3334%203.66675%2016.6024%203.66675%2012C3.66675%207.39765%207.39771%203.66669%2012.0001%203.66669C16.6025%203.66669%2020.3334%207.39765%2020.3334%2012C20.3284%2016.6003%2016.6004%2020.3283%2012.0001%2020.3334ZM12.0001%205.33335C8.31818%205.33335%205.33341%208.31812%205.33341%2012C5.33341%2015.6819%208.31818%2018.6667%2012.0001%2018.6667C15.682%2018.6667%2018.6667%2015.6819%2018.6667%2012C18.6626%208.31984%2015.6803%205.33749%2012.0001%205.33335ZM12.0001%2017C10.6834%2017.0223%209.43891%2016.4%208.66675%2015.3334C8.29181%2014.8319%208.00959%2014.2675%207.83342%2013.6667H16.1667C16.1667%2013.6667%2016.1667%2013.6667%2016.1667%2013.6734C15.9879%2014.271%2015.7058%2014.8328%2015.3334%2015.3334C14.5612%2016.3999%2013.3167%2017.0222%2012.0001%2017ZM9.08342%2012C8.39306%2012%207.83342%2011.4404%207.83342%2010.75C7.83342%2010.0597%208.39306%209.50002%209.08342%209.50002C9.77377%209.50002%2010.3334%2010.0597%2010.3334%2010.75C10.3334%2011.4404%209.77377%2012%209.08342%2012ZM14.9109%2011.9884C14.2238%2011.9884%2013.6667%2011.4313%2013.6667%2010.7442C13.6667%2010.0571%2014.2238%209.50002%2014.9109%209.50002C15.598%209.50002%2016.1551%2010.0571%2016.1551%2010.7442C16.1542%2011.4309%2015.5977%2011.9874%2014.9109%2011.9884Z'%20fill='%23353535'/%3e%3c/svg%3e";
const Hyperlink = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M16.1667%2016.1667H13.6667V14.5H16.1667C17.5475%2014.5%2018.6667%2013.3807%2018.6667%2012C18.6667%2010.6193%2017.5475%209.50001%2016.1667%209.50001H13.6667V7.83334H16.1667C18.4679%207.83334%2020.3334%209.69882%2020.3334%2012C20.3334%2014.3012%2018.4679%2016.1667%2016.1667%2016.1667ZM10.3334%2016.1667H7.83342C5.53223%2016.1667%203.66675%2014.3012%203.66675%2012C3.66675%209.69882%205.53223%207.83334%207.83342%207.83334H10.3334V9.50001H7.83342C6.4527%209.50001%205.33341%2010.6193%205.33341%2012C5.33341%2013.3807%206.4527%2014.5%207.83342%2014.5H10.3334V16.1667ZM16.1667%2012.8333H7.83342V11.1667H16.1667V12.8333Z'%20fill='%23495057'/%3e%3c/svg%3e";
const Attachment = "data:image/svg+xml,%3csvg%20width='10'%20height='16'%20viewBox='0%200%2010%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M9.60686%2010.1869C9.60686%2010.6011%209.27108%2010.9369%208.85686%2010.9369C8.44265%2010.9369%208.10686%2010.6011%208.10686%2010.1869V5.375C8.10686%203.61117%206.71225%202.1875%204.99972%202.1875C3.2872%202.1875%201.89258%203.61117%201.89258%205.375V11.9375C1.89258%2012.9765%202.71156%2013.8125%203.71401%2013.8125C4.71645%2013.8125%205.53544%2012.9765%205.53544%2011.9375V5.375C5.53544%205.06092%205.29209%204.8125%204.99972%204.8125C4.70736%204.8125%204.46401%205.06092%204.46401%205.375V11.0625C4.46401%2011.4767%204.12822%2011.8125%203.71401%2011.8125C3.29979%2011.8125%202.96401%2011.4767%202.96401%2011.0625V5.375C2.96401%204.23934%203.87193%203.3125%204.99972%203.3125C6.12752%203.3125%207.03544%204.23934%207.03544%205.375V11.9375C7.03544%2013.798%205.55188%2015.3125%203.71401%2015.3125C1.87613%2015.3125%200.392578%2013.798%200.392578%2011.9375V5.375C0.392578%202.78959%202.45177%200.6875%204.99972%200.6875C7.54768%200.6875%209.60686%202.78959%209.60686%205.375V10.1869Z'%20fill='%23696969'/%3e%3c/svg%3e";
const images = {
  QuickReplies,
  // Inline
  Bold,
  Italic,
  Underline,
  // List
  Ordered,
  Unordered,
  Emoji,
  Hyperlink,
  Attachment
};
const CLASS_ACTIVE = "active";
const Toolbar = ({ editor, quickReplies, UploadAttachmentsButton }) => {
  const [showLink, setShowLink] = React.useState(false);
  const [showEmoji, setShowEmoji] = React.useState(false);
  const [showQuickReplies, setShowQuickReplies] = React.useState(false);
  const [isBold, setIsBold] = React.useState(false);
  const [isItalic, setIsItalic] = React.useState(false);
  const [isUnderline, setIsUnderline] = React.useState(false);
  const [isUL, setIsUL] = React.useState(false);
  const [isOL, setIsOL] = React.useState(false);
  const updateToolbar = React.useCallback(() => {
    const selection = $getSelection();
    if (!$isRangeSelection(selection)) {
      setIsBold(false);
      setIsItalic(false);
      setIsUnderline(false);
      setIsUL(false);
      setIsOL(false);
      return;
    }
    setIsBold(selection.hasFormat("bold"));
    setIsItalic(selection.hasFormat("italic"));
    setIsUnderline(selection.hasFormat("underline"));
    const anchor = selection.anchor.getNode();
    const top = anchor.getTopLevelElement();
    if ($isListNode(top)) {
      const t = top.getListType();
      setIsUL(t === "bullet");
      setIsOL(t === "number");
    } else {
      setIsUL(false);
      setIsOL(false);
    }
  }, []);
  React.useEffect(() => {
    return j(
      editor.registerUpdateListener(({ editorState }) => {
        editorState.read(updateToolbar);
      }),
      editor.registerCommand(
        SELECTION_CHANGE_COMMAND,
        () => {
          editor.getEditorState().read(updateToolbar);
          return false;
        },
        COMMAND_PRIORITY_LOW
      )
    );
  }, [editor, updateToolbar]);
  const onToolbarMouseDown = (e) => {
    e.preventDefault();
    editor.focus();
  };
  return /* @__PURE__ */ jsxs("div", { className: "lexicalEditor-toolbar", role: "toolbar", children: [
    /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        className: "lexicalEditor-toolbar-button",
        onClick: () => setShowQuickReplies((v) => !v),
        "aria-label": "Quick Replies",
        title: "Quick Replies",
        children: /* @__PURE__ */ jsx(
          "img",
          {
            className: "lexicalEditor-toolbar-icon",
            src: images.QuickReplies,
            alt: "Quick Replies"
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        className: `lexicalEditor-toolbar-button ${isBold ? CLASS_ACTIVE : ""}`,
        onClick: () => editor.dispatchCommand(FORMAT_TEXT_COMMAND, "bold"),
        onMouseDown: onToolbarMouseDown,
        "aria-label": "Bold",
        title: "Bold (Ctrl/Cmd+B)",
        children: /* @__PURE__ */ jsx("img", { className: "lexicalEditor-toolbar-icon", src: images.Bold, alt: "Bold" })
      }
    ),
    /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        className: `lexicalEditor-toolbar-button ${isItalic ? CLASS_ACTIVE : ""}`,
        onClick: () => editor.dispatchCommand(FORMAT_TEXT_COMMAND, "italic"),
        onMouseDown: onToolbarMouseDown,
        "aria-label": "Italic",
        title: "Italic (Ctrl/Cmd+I)",
        children: /* @__PURE__ */ jsx(
          "img",
          {
            className: "lexicalEditor-toolbar-icon",
            src: images.Italic,
            alt: "Italic"
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        className: `lexicalEditor-toolbar-button ${isUnderline ? CLASS_ACTIVE : ""}`,
        onClick: () => editor.dispatchCommand(FORMAT_TEXT_COMMAND, "underline"),
        onMouseDown: onToolbarMouseDown,
        "aria-label": "Underline",
        title: "Underline (Ctrl/Cmd+U)",
        children: /* @__PURE__ */ jsx(
          "img",
          {
            className: "lexicalEditor-toolbar-icon",
            src: images.Underline,
            alt: "Underline"
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        className: `lexicalEditor-toolbar-button ${isUL ? CLASS_ACTIVE : ""}`,
        onClick: () => isUL ? editor.dispatchCommand(REMOVE_LIST_COMMAND, void 0) : editor.dispatchCommand(INSERT_UNORDERED_LIST_COMMAND, void 0),
        onMouseDown: onToolbarMouseDown,
        "aria-label": "Bullet List",
        title: "Bullet List",
        children: /* @__PURE__ */ jsx(
          "img",
          {
            className: "lexicalEditor-toolbar-icon",
            src: images.Unordered,
            alt: "Bullet List"
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        className: `lexicalEditor-toolbar-button ${isOL ? CLASS_ACTIVE : ""}`,
        onClick: () => isOL ? editor.dispatchCommand(REMOVE_LIST_COMMAND, void 0) : editor.dispatchCommand(INSERT_ORDERED_LIST_COMMAND, void 0),
        onMouseDown: onToolbarMouseDown,
        "aria-label": "Numbered List",
        title: "Numbered List",
        children: /* @__PURE__ */ jsx(
          "img",
          {
            className: "lexicalEditor-toolbar-icon",
            src: images.Ordered,
            alt: "Numbered List"
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        className: "lexicalEditor-toolbar-button",
        onClick: () => setShowLink((v) => !v),
        "aria-label": "Insert Link",
        title: "Insert Link",
        children: /* @__PURE__ */ jsx(
          "img",
          {
            className: "lexicalEditor-toolbar-icon",
            src: images.Hyperlink,
            alt: "Insert Link"
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        className: "lexicalEditor-toolbar-button",
        onClick: () => setShowEmoji((v) => !v),
        "aria-label": "Insert Emoji",
        title: "Insert Emoji",
        children: /* @__PURE__ */ jsx(
          "img",
          {
            className: "lexicalEditor-toolbar-icon",
            src: images.Emoji,
            alt: "Insert Emoji"
          }
        )
      }
    ),
    UploadAttachmentsButton,
    showLink && /* @__PURE__ */ jsx(
      InsertLinkModal,
      {
        open: showLink,
        onConfirm: (title, url) => {
          setShowLink(false);
        },
        onClose: () => setShowLink(false)
      }
    ),
    showEmoji && /* @__PURE__ */ jsx(InsertEmojiModal, { onClose: () => setShowEmoji(false) }),
    showQuickReplies && /* @__PURE__ */ jsx(
      QuickRepliesModal,
      {
        quickReplies,
        onClose: () => setShowQuickReplies(false)
      }
    )
  ] });
};
const baseClass = "lexicalEditor-content";
const theme = {
  paragraph: "leading-7",
  text: {
    bold: `${baseClass}-bold`,
    italic: `${baseClass}-italic`,
    underline: `${baseClass}-underline`,
    strikethrough: `${baseClass}-strikethrough`
  },
  heading: {
    h1: "text-3xl font-bold",
    h2: "text-2xl font-semibold",
    h3: "text-xl font-semibold"
  },
  link: `${baseClass}-link`
};
const initialConfig = {
  namespace: "basic-lexical-editor",
  theme,
  onError(error) {
    console.error(error);
  },
  nodes: [HeadingNode, QuoteNode, ListNode, ListItemNode, LinkNode]
};
function ExternalStateSyncPlugin({
  docId,
  incoming
}) {
  const [editor] = useLexicalComposerContext();
  const appliedForDocRef = React.useRef(void 0);
  React.useEffect(() => {
    const key = docId ?? "__default__";
    if (appliedForDocRef.current === key)
      return;
    if (incoming) {
      try {
        const parsed = editor.parseEditorState(incoming);
        editor.setEditorState(parsed);
      } catch (e) {
        console.error("Failed to parse serialized state", e);
        editor.update(() => {
          const root = $getRoot();
          root.clear();
          root.append($createParagraphNode().append($createTextNode("")));
        });
      }
    } else {
      editor.update(() => {
        const root = $getRoot();
        root.clear();
        root.append($createParagraphNode().append($createTextNode("")));
      });
    }
    appliedForDocRef.current = key;
  }, [editor, docId]);
  return null;
}
const InnerEditor = forwardRef(
  ({
    placeholder,
    docId,
    editorState,
    SendButton,
    UploadAttachmentsButton,
    CcReplyButton,
    quickReplies,
    onEditorStateChange
  }, ref) => {
    const [editor] = useLexicalComposerContext();
    useImperativeHandle(
      ref,
      () => ({
        insertText(text) {
          editor.update(() => {
            const selection = $getSelection();
            if ($isRangeSelection(selection)) {
              selection.insertText(text);
            }
          });
        },
        getText() {
          let text = "";
          editor.read(() => {
            text = $getRoot().getTextContent();
          });
          return text;
        },
        getHtml() {
          let html = "";
          editor.read(() => {
            html = $generateHtmlFromNodes(editor);
          });
          return html;
        },
        setHTML(html) {
          const parser = new DOMParser();
          const dom = parser.parseFromString(html, "text/html");
          editor.update(() => {
            const root = $getRoot();
            root.clear();
            const nodes = $generateNodesFromDOM(editor, dom);
            if (nodes.length === 0) {
              root.append($createParagraphNode());
            } else {
              root.append(...nodes);
            }
          });
        },
        getMarkdown() {
          let markdown = "";
          editor.read(() => {
            markdown = $convertToMarkdownString(TRANSFORMERS, void 0, true);
          });
          return markdown;
        },
        isEmpty() {
          let text = "";
          editor.read(() => {
            text = $getRoot().getTextContent();
          });
          return text.trim().length === 0;
        },
        clear() {
          editor.update(() => {
            const root = $getRoot();
            root.clear();
          });
        },
        focus() {
          editor.focus();
        }
      }),
      [editor]
    );
    return /* @__PURE__ */ jsxs("div", { className: "lexicalEditor-wrapper", children: [
      /* @__PURE__ */ jsx(
        Toolbar,
        {
          editor,
          UploadAttachmentsButton,
          quickReplies
        }
      ),
      /* @__PURE__ */ jsx(
        RichTextPlugin,
        {
          contentEditable: /* @__PURE__ */ jsx(
            ContentEditable,
            {
              className: "lexicalEditor-content",
              "aria-label": "Text editor"
            }
          ),
          placeholder: /* @__PURE__ */ jsx("div", { className: "lexicalEditor-placeholder", children: placeholder }),
          ErrorBoundary: LexicalErrorBoundary
        }
      ),
      /* @__PURE__ */ jsx("div", { className: "lexicalEditor-attachments" }),
      /* @__PURE__ */ jsxs("div", { className: "lexicalEditor-footer", children: [
        CcReplyButton,
        SendButton
      ] }),
      /* @__PURE__ */ jsx(HistoryPlugin, {}),
      /* @__PURE__ */ jsx(ListPlugin, {}),
      /* @__PURE__ */ jsx(LinkPlugin, {}),
      /* @__PURE__ */ jsx(
        OnChangePlugin,
        {
          onChange: (editorState2) => {
            onEditorStateChange(editorState2);
          }
        }
      ),
      /* @__PURE__ */ jsx(ExternalStateSyncPlugin, { docId, incoming: editorState ?? null })
    ] });
  }
);
InnerEditor.displayName = "InnerEditor";
const LexicalEditor = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx(LexicalComposer, { initialConfig, children: /* @__PURE__ */ jsx(InnerEditor, { ref, ...props }) });
});
LexicalEditor.displayName = "Editor";
export {
  LexicalEditor
};
